import { useQuery } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';
import { FormSubmission } from '../../../types/FormSubmission';

const fetchFormSubmissionPreview = async (uuid: string | undefined) => {
  if (uuid === undefined) return null;

  const response = await CustomAxios.get<FormSubmission>(`form_submissions/${uuid}/preview`);
  const { data } = response;
  return data;
};

interface UseGetFormSubmissionPreviewByIdProps {
  uuid?: string;
  enabled?: boolean;
}

export function useGetFormSubmissionPreviewById({ uuid, enabled = true }: UseGetFormSubmissionPreviewByIdProps) {
  return useQuery({
    queryKey: [queryKeys.allFormSubmissionPreviews, uuid],
    queryFn: () => fetchFormSubmissionPreview(uuid),
    enabled,
  });
}
